import { Typography } from '@mui/material';
import { useState } from 'react';
import { API } from '../../../../api/api';
import { URLS } from '../../../../api/urls';
import { Modal } from '../../../../components/Modal/Modal';
import { ALERT_TEXT } from '../../../../constants/content';
import { useAlert } from '../../../../context/Alert.context';
import { BannerForm } from './BannerForm';
import { BannersDTO } from '../../types';

interface CreatePageModalProps {
  open: boolean;
  onClose: () => void;
  updateBannerAfterCreate: (banner: BannersDTO) => void;
}

export const CreateModal = ({
                              open,
                              onClose,
                              updateBannerAfterCreate,
                            }: CreatePageModalProps) => {
  const [loading, setLoading] = useState(false);
  const { showAlert } = useAlert();


  const create = ( { page, file }: { page: BannersDTO; file: File | null }) => {
    setLoading(true);
    const formData = new FormData();
    formData.append('dto', JSON.stringify(page));
    if (file) {
      formData.append('image', file);
    }
    API.post(URLS.BANNERS, formData)
      .then(({ data }) => {
        updateBannerAfterCreate(data);
        onClose();
        showAlert({
          message: ALERT_TEXT.BANNER_CREATED_SUCCESS,
          severity: 'success',
        });
      })
      .catch((e) => showAlert({ message: e.message, severity: 'error' }))
      .finally(() => setLoading(false));
  };

  return (
    <Modal
      shouldPreventModal
      title={<Typography variant="h6">Add banner</Typography>}
      open={open}
      onClose={onClose}
    >
      <BannerForm loading={loading} onSubmit={create} onCancel={onClose} />
    </Modal>
  );
};
